import React from 'react';
import { SVGProps } from './type';

export const IconAddProduct = ({ fill }: SVGProps) => (
  <g>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.9334 3.6001H6.93343C5.09248 3.6001 3.6001 5.09248 3.6001 6.93343V16.9334C3.6001 18.7744 5.09248 20.2668 6.93343 20.2668H16.9334C18.7744 20.2668 20.2668 18.7744 20.2668 16.9334V6.93343C20.2668 5.09248 18.7744 3.6001 16.9334 3.6001ZM5.26676 6.93343C5.26676 6.01296 6.01296 5.26676 6.93343 5.26676H16.9334C17.8539 5.26676 18.6001 6.01296 18.6001 6.93343V16.9334C18.6001 17.8539 17.8539 18.6001 16.9334 18.6001H6.93343C6.01296 18.6001 5.26676 17.8539 5.26676 16.9334V6.93343ZM12.7668 11.1002H15.6834C16.1437 11.1002 16.5168 11.4733 16.5168 11.9336C16.5168 12.3938 16.1437 12.7669 15.6834 12.7669H12.7668V15.6836C12.7668 16.1438 12.3937 16.5169 11.9334 16.5169C11.4732 16.5169 11.1001 16.1438 11.1001 15.6836V12.7669H8.18344C7.7232 12.7669 7.35011 12.3938 7.35011 11.9336C7.35011 11.4733 7.7232 11.1002 8.18344 11.1002H11.1001V8.18355C11.1001 7.72332 11.4732 7.35022 11.9334 7.35022C12.3937 7.35022 12.7668 7.72332 12.7668 8.18355V11.1002Z"
      fill={fill}
    />
  </g>
);
